export default {"src":"/_next/static/media/FI.bb9e5195.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};